/*
 * @File: sug卡片推荐组件
 */

import {SUG_CARD_CONFIG} from '@lib/constants';
import {Component} from '@src/lib/San';
import CSugCards from '../c-sug-cards';
import CSugLaw from '../c-sug-law';
import $style from './index.module.less';

export default class CSugRecommend extends Component {
    static template = /* html */ `
        <div class="{{$style.cardWrapper}}">
            <!-- 法律卡片 -->
            <c-sug-law
                s-if="sugType === '${SUG_CARD_CONFIG.LAWSUG}'"
                id="{{id}}"
                sug-bots="{{sugBots}}"
                title="{{title}}"
                checked="{{checked}}"
                is-history="{{isHistory}}"
            />
            <c-sug-cards
                s-else
                id="{{id}}"
                sug-bots="{{sugBots}}"
                log-info="{{logInfo}}"
                title="{{title}}"
                from="{{from}}"
                need-log="{{needLog}}"
                checked="{{checked}}"
                is-history="{{isHistory}}"
            />
        </div>
    `;

    static components = {
        'c-sug-cards': CSugCards,
        'c-sug-law': CSugLaw,
    };

    initData() {
        return {
            $style,
        };
    }
}

